import { render, staticRenderFns } from "./GameResult.vue?vue&type=template&id=a9a8fede&scoped=true"
import script from "./GameResult.vue?vue&type=script&lang=js"
export * from "./GameResult.vue?vue&type=script&lang=js"
import style0 from "./GameResult.vue?vue&type=style&index=0&id=a9a8fede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a8fede",
  null
  
)

export default component.exports